import React from 'react';
import TextField from '@mui/material/TextField';
import { withFormsy } from 'formsy-react';

import { pick } from 'lodash';

function TextFieldFormsy(props) {
  const importedProps = pick(props, [
    'autoComplete',
    'autoFocus',
    'children',
    'className',
    'defaultValue',
    'disabled',
    'FormHelperTextProps',
    'fullWidth',
    'id',
    'InputLabelProps',
    'inputProps',
    'InputProps',
    'inputRef',
    'label',
    'multiline',
    'name',
    'onBlur',
    'onChange',
    'onFocus',
    'placeholder',
    'required',
    'rows',
    'rowsMax',
    'select',
    'SelectProps',
    'type',
    'variant',
    'color',
  ]);

  const { errorMessage, description } = props;
  const value = props.value;

  function changeValue(event) {
    props.setValue(event.currentTarget.value);
    if (props.onChange) {
      props.onChange(event);
    }
  }

  return (
    <TextField
      {...importedProps}
      variant="outlined"
      onChange={changeValue}
      value={value}
      error={Boolean((!props.isPristine && props.showRequired) || errorMessage)}
      helperText={errorMessage ?? description}
    />
  );
}

export default React.memo(withFormsy(TextFieldFormsy));
